export default "__VITE_ASSET__kyOdTOAy__"